@use "stylesheets/utility/variables";

.header {
  background-color: var(--bg-default);
  border-bottom: 1px solid var(--border-default);
  height: variables.$primary-header-height-mobile;

  @media (min-width: variables.$laptop) {
    height: variables.$primary-header-height;
  }
}

.container {
  display: flex;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  height: 100%;
  align-items: center;

  max-width: variables.$laptopL;
}

.logoLink {
  display: inline-block;
}

.logo {
  width: inherit;
  height: 28px;

  @media (min-width: variables.$laptop) {
    width: 116px;
    height: inherit;
  }
}

.contentSlot {
  flex: 1;
}

/* Desktop nav is inside the contentSlot div */
.contentSlot .nav {
  display: none;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing-md);

  @media (min-width: variables.$laptop) {
    display: flex;
  }
}

.mobileNavButton {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: variables.$laptop) {
    display: none;
  }
}

.mobileMenu {
  flex: 1;
}

/* Mobile nav is inside the mobile menu overlay */
.mobileMenu .nav {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
  padding: var(--spacing-2xl) var(--spacing-lg);
}

.link {
  display: block;
  padding: 0 var(--spacing-md);
}

.mobileMenu .link {
  padding: var(--spacing-sm) 0;
}

.mobileMenu .loginBtn {
  margin-top: var(--spacing-md);
}

.mobileMenu button {
  display: block;
  width: 100%;
}

.headerButton {
  height: variables.$primary-header-height-mobile;
  &:focus {
    box-shadow: none !important;
  }
  &:hover {
    background-color: inherit !important;
  }
}

.mobileSlot {
  display: block;
  position: relative;
  z-index: 2;

  @media (min-width: variables.$laptop) {
    display: none;
  }
}
